import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'

const PHASES = [
  { key: 'connect', numeral: '1' },
  { key: 'autoAssociate', numeral: '2' },
  { key: 'doStuff', numeral: '3' },
] as const

export function HowItWorks() {
  const { t } = useTranslation()

  return (
    <section id="how-it-works" className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-12">
      <ScrollFade as="h2" className="text-3xl md:text-4xl font-bold font-display">
        {t('surfaces.howItWorks')}
      </ScrollFade>
      <div className="mt-10 md:mt-12 space-y-10 md:space-y-16">
        {PHASES.map((phase, i) => (
          <ScrollFade
            key={phase.key}
            delay={i * 120}
            className="grid grid-cols-[44px_1fr] md:grid-cols-[120px_1fr] gap-3 md:gap-8 items-baseline md:items-start"
          >
            <div className="text-3xl md:text-6xl font-bold font-display opacity-30 leading-none tabular-nums">
              {phase.numeral}
            </div>
            <div>
              <div className="text-2xl md:text-4xl font-bold font-display leading-tight">
                {t(`surfaces.${phase.key}`)}
              </div>
              <p className="mt-3 text-lg opacity-80 max-w-prose leading-relaxed">
                {t(`lorem:howItWorks.${phase.key}.body`)}
              </p>
            </div>
          </ScrollFade>
        ))}
      </div>
    </section>
  )
}
